<!-- 商品管理 V2 - 信息维护列表页 -->
<template>
  <div class="product-management-v2">
    <!-- 页面头部 -->
    <Head />
    <main class="page-content">
      <!-- 状态 Tab：全部 / 待维护 / 维护中 / 待审核 / 维护完成 -->
      <div class="status-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        type="button"
        :class="{ active: !noNeedOnly && query.tab === tab.value }"
        @click="changeStatus(tab.value)"
      >
        {{ tab.label }}<span v-if="tab.countKey && tabCounts[tab.countKey] !== undefined">（{{ tabCounts[tab.countKey] }}）</span>
      </button>
    
    </div>

    <!-- 搜索筛选面板 -->
    <search-panel ref="searchPanel" :flag-list="flagList" :active-tab="query.tab" @search="search" />

    <!-- 批量操作工具栏 -->
    <div class="toolbar">
      <div class="toolbar-actions">
        <!-- 创建商品 -->
        <el-button v-if="isAuth(769)" class="red-action" size="small" @click="createDialogVisible = true">{{ $t('message.productV2CreateProduct') }}</el-button>
        <!-- 删除 -->
        <el-button v-if="isAuth(770)" class="dark-action" size="small" @click="batchDelete">{{ $t('message.delete') }}</el-button>
        <!-- 批量提交审核 -->
        <el-button v-if="isAuth(771) && (query.tab === 'all' ||query.tab === 'wait' || query.tab === 'maintaining')" class="blue-action" size="small" @click="batchSubmitAudit">{{ $t('message.productV2BatchSubmitAudit') }}</el-button>
        <!-- 批量提交无需维护 -->
        <el-button v-if="isAuth(772) && (query.tab === 'all' ||query.tab === 'wait' || query.tab === 'maintaining')" class="blue-action" size="small" @click="batchSubmitNoNeed">{{ $t('message.productV2BatchNoNeed') }}</el-button>
        <!-- 批量审核 -->
        <el-button v-if="isAuth(773) && query.tab === 'pending_audit'" class="red-action" size="small" @click="batchAudit">{{ $t('message.productV2BatchAudit') }}</el-button>
        <!-- 提出订单 -->
        <el-button class="green-action" size="small" @click="raiseOrderCheck"  v-if="isAuth(154)">{{ $t('message.submitOrder') }}</el-button>
        <!-- 客户商品数据导出全部 -->
        <el-button v-if="isAuth(632)" class="blue-action" size="small" @click="productListExport(1)">{{ $t('message.customerProductDataExportAll') }}</el-button>
        <!-- 客户商品数据导出 -->
        <el-button v-if="isAuth(633)" class="blue-action" size="small" @click="productListExport(0)">{{ $t('message.customerProductDataExport') }}</el-button>
        <!-- 导入一件商品数据 -->
        <el-button class="blue-action" size="small" @click="importOneItemOfProductData">{{ $t('message.importOneItemOfProductData') }}</el-button>
      </div>
      <div class="toolbar-right">
        <!-- 跨页勾选数量，点击打开已选列表弹框 -->
        <button type="button" class="selected-count" @click="openSelectedList">
          {{ $t('message.productV2SelectedCount') }}：<em>{{ selectedList.length }}</em>
        </button>
        <!-- 一键展开/收起列表 -->
        <el-button class="expand-action" size="small" @click="toggleAll">
          {{ allExpanded ? $t('message.listCollapse') : $t('message.listExpansion') }}
          <i :class="allExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
    </div>

    <!-- 商品列表表格 -->
    <product-table
      ref="productTable"
      :table-data="tableData"
      :loading="loading"
      :page="query.page"
      :page-size="query.pageSize"
      @selection-change="handleSelectionChange"
      @edit-code="editCode"
      @bind-spu="openBindSpu"
      @product-link="openProductLink"
      @maintain="openMaintenance"
    />

    <!-- 分页 -->
    <div v-if="total" class="pagination">
      <el-pagination
        :current-page="query.page"
        :page-sizes="[20, 50,100,200]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="changePageSize"
        @current-change="changePage"
      />
    </div>

    <!-- 手动创建商品弹窗 -->
    <el-dialog :title="$t('message.productV2CreateProduct')" :visible.sync="createDialogVisible" width="480px">
      <el-form :model="createForm" label-width="130px">
        <el-form-item :label="$t('message.customerID_CustomerName')" required>
          <el-input v-model="createForm.user_id" />
        </el-form-item>
        <el-form-item :label="$t('message.managementDesignation')">
          <el-input v-model="createForm.client_sku_code" />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="generateClientSkuCode">
            {{ $t('message.creationManagementDesignation') }}
          </el-button>
          <el-popover
            placement="top"
            width="300"
            trigger="hover"
            content="点击按钮生成公司统一格式的管理番号，用于给没有自己管理番号的客户管理商品，管理番号生成后，会自动复制到粘贴板，可直接给客户进行商品分组"
          >
            <i slot="reference" class="el-icon-question generate-code-help"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createDialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button v-if="isAuth(769)" type="primary" @click="manualCreate">{{ $t('message.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 商品信息维护弹窗 -->
    <el-dialog :title="$t('message.productV2Maintain')" :visible.sync="maintenanceVisible" width="680px">
      <el-form v-loading="detailLoading" :model="detailForm" label-width="130px">
        <el-form-item :label="$t('message.managementDesignation')">
          <el-input v-model="detailForm.client_sku_code" />
        </el-form-item>
        <el-form-item :label="$t('message.productNameChinese')">
          <el-input v-model="detailForm.goods_title_cn" />
        </el-form-item>
        <el-form-item :label="$t('message.productNameJapanese')">
          <el-input v-model="detailForm.goods_title" />
        </el-form-item>
        <el-form-item :label="$t('message.productManagementRemarks')">
          <el-input v-model="detailForm.remark" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item :label="$t('message.productV2BusinessRemark')">
          <el-input v-model="detailForm.business_remark" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="maintenanceVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button v-if="isAuth(769)" type="primary" :loading="saving" @click="saveDetail">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>

    <!-- 商品数据导入 -->
    <import-excel ref="importExcel" :user_id="query.user_id || ''" import-path="/admin/product/v2/batchImport" @search="loadList" />
    <edit-client-sku-dialog ref="editClientSkuDialog" @success="loadList" />
    <bind-spu-dialog ref="bindSpuDialog" />
    <product-link-history-dialog ref="productLinkHistoryDialog" />
    <delete-product-dialog ref="deleteProductDialog" @success="onDeleteSuccess" />
    <submit-audit-dialog ref="submitAuditDialog" @success="onDeleteSuccess" />
    <batch-audit-dialog ref="noNeedDialog" @success="onDeleteSuccess" />
    <batch-audit-dialog ref="batchAuditDialog" @success="onDeleteSuccess" />
    <raise-order-dialog ref="raiseOrderDialog" @maintain="openMaintenance" @ready="openOrderPreview" />
    <!-- 跨页已勾选商品列表 -->
    <selected-list-dialog ref="selectedListDialog" :list="selectedList" @remove="removeSelected" />
    </main>
  </div>
</template>

<script>
import searchPanel from './components/searchPanel'
import productTable from './components/productTable'
import editClientSkuDialog from './components/editClientSkuDialog'
import bindSpuDialog from './components/bindSpuDialog'
import productLinkHistoryDialog from './components/productLinkHistoryDialog'
import deleteProductDialog from './components/deleteProductDialog'
import submitAuditDialog from './components/submitAuditDialog'
import batchAuditDialog from './components/batchAuditDialog'
import raiseOrderDialog from './components/raiseOrderDialog'
import selectedListDialog from './components/selectedListDialog'
import importExcel from '@/views/productManagement/informationMaintenance/components/dataMaintenance/importExcel'
import Head from '@/components/header/detailHeader'
import qs from 'qs'

export default {
  name: 'ProductManagementV2',
  components: { Head, searchPanel, productTable, editClientSkuDialog, bindSpuDialog, productLinkHistoryDialog, deleteProductDialog, submitAuditDialog, batchAuditDialog, raiseOrderDialog, selectedListDialog, importExcel },
  data() {
    return {
      // 状态 Tab 配置，countKey 对应 tabCounts 接口返回的字段
      tabs: [
        { label: this.$t('message.productV2AllProducts'), value: 'all', countKey: 'all' },
        { label: this.$t('message.productV2PendingMaintenance'), value: 'wait', countKey: 'wait' },
        { label: this.$t('message.productV2Maintaining'), value: 'maintaining', countKey: 'maintaining' },
        { label: this.$t('message.productV2PendingAudit'), value: 'pending_audit', countKey: 'pending_audit' },
        { label: this.$t('message.productV2MaintenanceCompleted'), value: 'done', countKey: 'done' }
      ],
      query: {
        page: 1,
        pageSize: 20,
        tab: 'all',
        user_id: '',
        goods_id_or_link: '',
        factory_contact: '',
        has_material: '',
        has_extra_service: '',
        y_remark: '',
        remark: '',
        tags: [],
        user_id_or_name: '',
        client_sku_code: '',
        spu: '',
        supply_type: '',
        label_no: '',
        goods_code: '',
        view_plan_id: '',
        maintain_status: '',
        audit_type: ''
      },
      tabCounts: {}, // 各状态 Tab 数量
      flagList: [], // 商品标签下拉选项
      tableData: [],
      selectedList: [], // 跨页勾选列表（翻页保留）
      total: 0,
      loading: false,
      allExpanded: false, // 列表展开/折叠状态
      createDialogVisible: false,
      createForm: { user_id: '', client_sku_code: '' },
      maintenanceVisible: false,
      detailLoading: false,
      saving: false,
      detailForm: {}, // 维护弹窗表单数据
      exportLoading: null,
      noNeedOnly: false
    }
  },
  created() {
    if (this.$route.query.user_id) {
      this.query.user_id = this.$route.query.user_id
    }
    if (this.$route.query.client_sku_code) {
      this.query.client_sku_code = this.$route.query.client_sku_code
    }
    this.loadFlagList()
    this.loadTabCounts()
    this.loadList()
  },
  methods: {
    // 加载商品标签列表
    loadFlagList() {
      this.$api.productManagementApi.flagList().then(res => {
        this.flagList = res.data
      })
    },
    // 加载各状态 Tab 数量
    loadTabCounts() {
      this.$api.productManagementApi.tabCounts().then(res => {
        this.tabCounts = res.data
      })
    },
    // 组装列表接口入参（与后端字段一致）
    buildListParams() {
      const {
        page,
        pageSize,
        tab,
        user_id,
        goods_id_or_link,
        factory_contact,
        has_material,
        has_extra_service,
        y_remark,
        remark,
        tags,
        user_id_or_name,
        client_sku_code,
        spu,
        supply_type,
        label_no,
        goods_code,
        view_plan_id,
        maintain_status,
        audit_type
      } = this.query

      const params = {
        page,
        pageSize,
        tab: tab || 'all'
      }

      if (user_id !== '' && user_id != null && !Number.isNaN(Number(user_id))) {
        params.user_id = Number(user_id)
      }
      if (goods_id_or_link) params.goods_id_or_link = goods_id_or_link
      if (factory_contact) params.factory_contact = factory_contact
      if (has_material !== '' && has_material != null) params.has_material = has_material
      if (has_extra_service !== '' && has_extra_service != null) params.has_extra_service = has_extra_service
      if (y_remark) params.y_remark = y_remark
      if (remark) params.remark = remark
      if (user_id_or_name) params.user_id_or_name = user_id_or_name
      if (client_sku_code) params.client_sku_code = client_sku_code
      if (spu) params.spu = spu
      if (supply_type) params.supply_type = supply_type
      if (label_no) params.label_no = label_no
      if (goods_code) params.goods_code = goods_code
      if (view_plan_id !== '' && view_plan_id != null && !Number.isNaN(Number(view_plan_id))) {
        params.view_plan_id = Number(view_plan_id)
      }
      if (tags && tags.length) params.tags = tags
      if (maintain_status) {
        params.maintain_status = maintain_status
      }
      if (audit_type) {
        params.audit_type = audit_type
      }

      return params
    },
    // 加载商品列表
    loadList() {
      this.loading = true
      return this.$api.productManagementApi.productListV2(this.buildListParams()).then(res => {
        const selectedCodes = new Set(this.selectedList.map(item => item.sys_code))
        res.data.data.forEach(item => {
          item.checked = selectedCodes.has(item.sys_code)
          item.show = false
          const plans = Array.isArray(item.order_plans) ? item.order_plans : []
          const defaultPlanIndex = plans.findIndex(plan => Number(plan && plan.is_default) === 1)
          if (item.default_plan_index == null) {
            item.default_plan_index = defaultPlanIndex >= 0
              ? defaultPlanIndex
              : (item.active_plan_index == null ? 0 : Number(item.active_plan_index))
          }
          if (item.active_plan_index == null) item.active_plan_index = item.default_plan_index
          // 回到当前页时刷新已选快照，保证批量操作数据最新
          if (item.checked) {
            const idx = this.selectedList.findIndex(row => row.sys_code === item.sys_code)
            if (idx >= 0) this.$set(this.selectedList, idx, item)
          }
        })
        this.tableData = res.data.data
        this.allExpanded = false
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    // 搜索筛选（重置到第 1 页）
    search(form) {
      this.noNeedOnly = false
      this.query = { ...this.query, ...form, page: 1 }
      this.loadList()
      this.loadTabCounts()
    },
    // 切换状态 Tab（tab: all/wait/maintaining/pending_audit/done）
    changeStatus(tab) {
      this.noNeedOnly = false
      this.query.tab = tab
      
      this.syncSearchPanelTabFilters()
      this.query.page = 1
      this.loadList()
    },
  
    syncSearchPanelTabFilters() {
      const panel = this.$refs.searchPanel
      if (!panel) return
      panel.form.maintain_status = this.query.maintain_status
      panel.form.audit_type = this.query.audit_type
    },
    changePage(page) {
      this.query.page = page
      this.loadList()
    },
    changePageSize(pageSize) {
      this.query.pageSize = pageSize
      this.query.page = 1
      this.loadList()
    },
    // 一键展开/折叠所有行详情
    toggleAll() {
      this.allExpanded = !this.allExpanded
      this.$refs.productTable.toggleAllRows(this.allExpanded)
    },
    // 获取已勾选商品的 sys_code 集合
    // 当前页勾选变化：合并进跨页 selectedList
    handleSelectionChange(pageChecked) {
      const pageCodes = new Set(this.tableData.map(item => item.sys_code))
      this.selectedList = this.selectedList.filter(item => !pageCodes.has(item.sys_code))
      this.selectedList = this.selectedList.concat(pageChecked)
    },
    // 打开已勾选列表弹框
    openSelectedList() {
      this.$refs.selectedListDialog.open()
    },
    // 从已选列表删除，并同步取消当前页勾选
    removeSelected(sys_code) {
      this.selectedList = this.selectedList.filter(item => item.sys_code !== sys_code)
      const row = this.tableData.find(item => item.sys_code === sys_code)
      if (row) this.$set(row, 'checked', false)
    },
    getSelectedCodes() {
      const sys_code_set = this.selectedList.map(item => item.sys_code)
      if (!sys_code_set.length) this.$message.error(this.$t('message.productV2SelectProduct'))
      return sys_code_set
    },
    // 批量删除
    batchDelete() {
      const sys_code_set = this.getSelectedCodes()
      if (!sys_code_set.length) return
      this.$refs.deleteProductDialog.open(this.selectedList)
    },
    onDeleteSuccess() {
      this.selectedList = []
      this.loadList()
      this.loadTabCounts()
    },
    // 批量提交审核
    batchSubmitAudit() {
      const sys_code_set = this.getSelectedCodes()
      if (!sys_code_set.length) return
      this.$refs.submitAuditDialog.open(this.selectedList)
    },
    // 批量标记无需维护
    batchSubmitNoNeed() {
      const sys_code_set = this.getSelectedCodes()
      if (!sys_code_set.length) return
      this.$refs.noNeedDialog.open(this.selectedList, 'no_need')
    },
    // 批量审核（仅待审核状态）
    batchAudit() {
      if (this.query.tab !== 'pending_audit') return
      const sys_code_set = this.getSelectedCodes()
      if (!sys_code_set.length) return
      this.$refs.batchAuditDialog.open(this.selectedList, 'audit')
    },
    // 批量发起提出订单
    raiseOrderCheck() {
      const sys_code_set = this.getSelectedCodes()
      if (!sys_code_set.length) return
      const userIds = [...new Set(this.selectedList.map(item => item.user_id))]
      if (userIds.length > 1) {
        return this.$message.error(this.$t('message.productV2SameCustomerOrder'))
      }
      this.$refs.raiseOrderDialog.open(this.selectedList)
    },
    async openOrderPreview(list) {
      const user_id = list[0].user_id
      if (list.some(item => item.user_id != user_id)) {
        return this.$message.error(this.$t('message.productV2SameCustomerOrder'))
      }
      const res = await this.$api.clienteleApi.orderPlanPreview({
        user_id,
        sys_code_set: list.map(item => item.sys_code)
      })
      if (res.code != 0 || res.success === false) {
        return this.$message.error(res.msg)
      }
      const goodsList = res.data.order_data.reduce((goods, shop) => goods.concat(shop.goods), [])
      // 商品管理提出订单时保留五类备注，供预览页和后续订单详情读取。
      const orderList = goodsList.map((goods, index) => ({
        ...goods,
        client_remark: goods.client_remark || '',
        delivery_remark: goods.delivery_remark || '',
        inspect_remark: goods.inspect_remark || '',
        purchase_remark: goods.purchase_remark || '',
        y_remark: goods.y_remark || '',
        order_sn: res.data.order_sn,
        sorting: index + 1,
        detail_y: goods.detail,
        sku_id_y: '',
        spec_id_y: '',
        confirm_num: goods.num,
        confirm_freight: '0.00',
        confirm_price: goods.price,
        is_material: false,
        material_id: '',
        // 预览页用数组形式的 material 初始化已绑定辅料。
        material: Array.isArray(goods.material) ? goods.material : null,
        material_detail: null
      }))
      const route = this.$router.resolve({
        path: `/orderPreview?userID=${user_id}&type=productManagementV2`
      })
      window.open(route.href, JSON.stringify({ orderList, y_reply: '', y_remark: '' }))
      // 提出订单成功后清空跨页勾选
      this.clearSelectedList()
    },
    // 清空已选列表，并取消当前页勾选状态
    clearSelectedList() {
      this.selectedList = []
      this.tableData.forEach(item => {
        if (item.checked) this.$set(item, 'checked', false)
      })
    },
    getCurrentUserId() {
      return this.query.user_id || (this.$refs.searchPanel && this.$refs.searchPanel.form.user_id) || ''
    },
    // 客户商品数据导出
    productListExport(type) {
      const userId = this.getCurrentUserId()
      if (!userId) {
        return this.$message.error(this.$t('message.customerID_CustomerName'))
      }
      this.query.user_id = userId
      this.exportLoading = this.$loading({
        lock: true,
        text: this.$t('message.export'),
        spinner: 'el-icon-loading fontSize50',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      const xhr = new XMLHttpRequest()
      const url = this.baseURL + '/admin/product/v2/batchExport'
      xhr.open('post', url, true)
      xhr.responseType = 'blob'
      xhr.setRequestHeader('accept', '*/*')
      xhr.setRequestHeader('accept-language', 'zh-CN')
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
      xhr.setRequestHeader('admintoken', 'Bearer ' + localStorage.getItem('japan_access_token'))
      xhr.onload = () => {
        if (xhr.status === 200 && xhr.response.type !== 'text/html') {
          const fileName = `客户数据导出（${userId}）`
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName)
          } else {
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(xhr.response)
            link.download = fileName
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
        }
        if (this.exportLoading) this.exportLoading.close()
      }
      xhr.send(qs.stringify({ user_id: userId, needAllMessage: type }))
    },
    // 商品数据一键导入
    importOneItemOfProductData() {
      const userId = this.getCurrentUserId()
      if (!userId) {
        return this.$message.error(this.$t('message.customerID_CustomerName'))
      }
      this.query.user_id = userId
      // 等父级绑定更新后再打开弹窗，禁止通过 ref 直接修改子组件 prop。
      this.$nextTick(() => this.$refs.importExcel.open())
    },
    // 批量操作通用入口（确认后调用对应 API）
    runBatchAction(apiName, data) {
      this.$confirm(this.$t('message.productV2ConfirmOperation'), this.$t('message.prompt'), {
        type: 'warning'
      }).then(() => this.$api.productManagementApi[apiName](data)).then(res => {
        this.$message.success(res.msg)
        this.loadList()
        this.loadTabCounts()
      }).catch(() => {})
    },
    // 编辑管理番号
    editCode(item) {
      this.$refs.editClientSkuDialog.open(item)
    },
    // 打开 SPU 绑定弹框
    openBindSpu(item) {
      this.$refs.bindSpuDialog.open(item)
    },
    // 查看商品级历史采购链接
    openProductLink(item) {
      this.$refs.productLinkHistoryDialog.open(item)
    },
    // 手动创建商品
    generateClientSkuCode() {
      if (!String(this.createForm.user_id || '').trim()) {
        return this.$message.error(this.$t('message.customerID_CustomerName'))
      }
      this.$api.productManagementApi.randClientSkuCode().then(res => {
        const data = res && res.data
        const code = data && typeof data === 'object'
          ? (data.client_sku_code || data.sys_code || data.code || '')
          : data
        if (code) this.createForm.client_sku_code = String(code)
      })
    },
    async manualCreate() {
      if (!this.createForm.user_id || !this.createForm.client_sku_code) {
        return this.$message.error(this.$t('message.productV2CompleteCreateInfo'))
      }
      const user_id = Number(this.createForm.user_id)
      const client_sku_code = this.createForm.client_sku_code.trim()
      this.$api.productManagementApi.manualCreate({ user_id, client_sku_code }).then(async res => {
        this.$message.success(res.msg)
        this.createDialogVisible = false
        this.createForm = { user_id: '', client_sku_code: '' }
        await this.loadList()
        this.loadTabCounts()
        this.openMaintenance({ user_id, sys_code: res.data.sys_code })
      })
    },
    // 新标签页打开商品维护详情，保留当前列表页
    openMaintenance(item) {
      const route = this.$router.resolve({
        name: 'productManagementV2Detail',
        query: {
          user_id: item.user_id,
          sys_code: item.sys_code
        }
      })
      window.open(route.href, '_blank')
    },
    // 保存商品维护信息
    saveDetail() {
      this.saving = true
      this.$api.productManagementApi.detailSave(this.detailForm).then(res => {
        this.$message.success(res.msg)
        this.maintenanceVisible = false
        this.loadList()
        this.loadTabCounts()
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-management-v2 {
  min-width: 1910px;
  min-height: 100vh;
  padding-bottom: 76px;
  background: #f8f8f8;
}

.page-content {
  margin: 24px;
  padding: 24px;
  background: #f8f8f8;
}

.status-tabs {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 20px;
  border-bottom: 1px solid #dcdfe6;

  button:not(.el-button) {
    height: 40px;
    margin-right: 42px;
    padding: 0 0 12px;
    border: 0;
    border-bottom: 3px solid transparent;
    background: transparent;
    color: #333;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
  }

  button.active {
    border-bottom-color: #b4272d;
    color: #b4272d;
  }

  .no-need-button {
    width: 124px;
    height: 40px;
    margin-left: auto;
  }

  .no-need-button.active {
    border-color: #b4272d;
    background: #b4272d;
    color: #fff;
  }
}

.generate-code-help {
  margin-left: 8px;
  color: #333;
  font-size: 16px;
  cursor: help;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  .toolbar-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .toolbar-right {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 16px;
  }

  .selected-count {
    padding: 0;
    border: 0;
    background: transparent;
    color: #333;
    font-size: 14px;
    cursor: pointer;

    em {
      font-style: normal;
      color: #b4272d;
      font-weight: 700;
    }
  }


  ::v-deep .el-button {
    height: 40px;
    margin-left: 0;
    margin-right: 12px;
    margin-bottom: 0;
    padding: 0 20px;
    border-radius: 4px;
  }

  ::v-deep .red-action {
    border-color: #b4272d;
    background: #b4272d;
    color: #fff;
  }

  ::v-deep .dark-action {
    border-color: #333;
    background: #333;
    color: #fff;
  }

  ::v-deep .blue-action {
    border-color: #2c96e7;
    background: #2c96e7;
    color: #fff;
  }

  ::v-deep .green-action {
    border-color: #15ad3c;
    background: #15ad3c;
    color: #fff;
  }

  ::v-deep .expand-action {
    flex-shrink: 0;
    border-color: #dcdfe6;
    background: #fff;
    color: #333;

    i {
      margin-left: 4px;
    }
  }
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
}

</style>
